import gql from 'graphql-tag';

export const ACCOUNT_QUERY = gql`
query getAccount($accountId: ID!) {
  account(id: $accountId) {
    id
    displayName
    type
    assessmentSections {
      behaviorSection {
        displayName
        dimensions {
          id
          name
          displayName
        }
        distortionDimensions {
          id
          name
          displayName
        }
      }
      cognitiveSection {
        displayName
        dimensions {
          id
          name
          displayName
        }
      }
      interestsSection {
        displayName
        dimensions {
          id
          name
          displayName
        }
      }
    }
    surveyCompetencies {
      id,
      displayName,
      abilities {
        id,
        displayName
      }
    }
  }
}
`;

export const HIERARCHY_ACCOUNT_DETAILS = gql`
query getAccountHierarchyDetails($id: ID!) {
  accountHierarchyDetails(id: $id) {
    id
    assessmentSections {
      behaviorSection {
        displayName
        dimensions {
          id
          name
          displayName
        }
        distortionDimensions {
          id
          name
          displayName
        }
      }
      cognitiveSection {
        displayName
        dimensions {
          id
          name
          displayName
        }
      }
      interestsSection {
        displayName
        dimensions {
          id
          name
          displayName
        }
      }
    }
    surveyCompetencies {
      id,
      displayName,
      abilities {
        id,
        displayName
      }
    }
    dimensionsInUse
    abilitiesInUse
  }
}
`;

export const ACCOUNT_HIERARCHY = gql`
query getHierarchy($accountId: ID!) {
  account(id: $accountId){
    id
    accountHierarchy {
      descendantId,
      descendantBrandDisplayName,
    }
  }
 }
 `;

export const ACCOUNTS_IN_HIERARCHY = gql`
 query accountHierarchyQuery($id: ID!, $first: Int!, $rows: Int!, $filter: String) {
  accountHierarchyForAccountContentManagement(id: $id, first: $first, rows: $rows, filter: $filter) {
      rootAccount {
        id
        displayName
        assessmentSections {
          behaviorSection {
            displayName
            dimensions {
              id
              name
              displayName
            }
            distortionDimensions {
              id
              name
              displayName
            }
          }
          cognitiveSection {
            displayName
            dimensions {
              id
              name
              displayName
            }
          }
          interestsSection {
            displayName
            dimensions {
              id
              name
              displayName
            }
          }
        }
        surveyCompetencies {
          id,
          displayName,
          abilities {
            id,
            displayName
          }
        }
        dimensionsInUse
        abilitiesInUse
      }
      descendantAccounts {
        id
        displayName
        assessmentSections {
          behaviorSection {
            displayName
            dimensions {
              id
              name
              displayName
            }
            distortionDimensions {
              id
              name
              displayName
            }
          }
          cognitiveSection {
            displayName
            dimensions {
              id
              name
              displayName
            }
          }
          interestsSection {
            displayName
            dimensions {
              id
              name
              displayName
            }
          }
        }
        surveyCompetencies {
          id,
          displayName,
          abilities {
            id,
            displayName
          }
        }
        dimensionsInUse
        abilitiesInUse
      }
      totalNumberOfDescendants
   }
 }
 `;
